import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20sophisticated%20atmospheric%20literary%20scene%2C%20warm%20rose%20and%20amber%20toned%20abstract%20composition%20with%20soft%20gradients%2C%20elegant%20texture%20like%20aged%20paper%20and%20silk%20fabric%2C%20subtle%20dramatic%20lighting%2C%20mysterious%20and%20romantic%20mood%2C%20clean%20minimal%20artistic%20background%2C%20no%20text%20or%20people&width=1800&height=1200&seq=hero-bg-main&orientation=landscape"
        alt="嫂子的诱惑 - 都市禁忌情感小说精选推荐"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-4xl md:text-6xl text-background-50 mb-4 leading-tight">
          嫂子的诱惑
        </h1>
        <p className="text-lg md:text-xl text-background-200 mb-3 max-w-2xl mx-auto">
          探索都市禁忌情感世界
        </p>
        <p className="text-sm md:text-base text-background-300/80 mb-8 max-w-xl mx-auto leading-relaxed">
          汇聚热门网络小说、影视改编作品与情感解析内容，深度剖析禁忌情感叙事结构，为言情小说爱好者提供最全面的作品导读与推荐榜单
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/taboo-love"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            探索禁忌之恋
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-100 rounded-full text-sm font-medium border border-background-50/20 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading text-accent-400">10,000+</p>
            <p className="text-xs text-background-300/70 mt-1">精选作品</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading text-accent-400">500万+</p>
            <p className="text-xs text-background-300/70 mt-1">月活跃读者</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading text-accent-400">98%</p>
            <p className="text-xs text-background-300/70 mt-1">读者满意度</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-background-50/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-background-50/40 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}